import { render, staticRenderFns } from "./CardReview.vue?vue&type=template&id=06f8a632&scoped=true&"
import script from "./CardReview.vue?vue&type=script&lang=js&"
export * from "./CardReview.vue?vue&type=script&lang=js&"
import style0 from "./CardReview.vue?vue&type=style&index=0&id=06f8a632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8a632",
  null
  
)

export default component.exports